import * as React from 'react';
import {Context} from '../../state/Store';
import './PersonalInfoComponent.css'
import RedwoodInputText from '../../common/Input/RedwoodInputText';
import RedwoodSelect from '../../common/Select/RedwoodSelect';
import Button from '../../common/Button/Button';
import {base_url} from '../../config/apiConfig';
import * as _ from 'lodash';
import {useTranslation, Trans} from "react-i18next";
import SendMetrics from '../../CourierService/SendMetrics';

const PersonalInfoComponent = (props) => {
  const {t} = useTranslation();
  const {error, updateError, updateTouched, touched} = props;
  const [state, dispatch] = React.useContext(Context);
  const addressFields = state.countryInfo !== undefined ? state.countryInfo.addressFields : {};
  const taxInfo = state.countryInfo !== undefined ? state.countryInfo.taxFields : {};

  const verifyAddress = () => {  
    let flag = false;
    let final = false;
    _.forIn(touched, function(value) {
      if(value === true) {
        flag =  true;
      }
    });
    let errorFlag = true;
    _.forIn(addressFields, function(value, key) {
      const finalKey = key.toLowerCase();
      if(value[0] === 'R' || value[0] === 'R*') {
        errorFlag = error[finalKey].val !== '' && errorFlag;
      }
      final = errorFlag;   
    });
    return flag ? true : !final;
  }

  const doClick = () => {
    dispatch({
      type: 'ADDRESS_VALIDATION',
      payload: false
    });
    props.openAccordionSection(1);
    
  }
  
  //GET API Call for states of a given country
  
  React.useEffect(() => {
    let statesList = [];
    if(state.country !== '') {
      fetch(
        `${base_url}/states?countryId=${state.country}`,
        {
          method: 'GET',
          headers: {'Content-Type': 'application/json'},
        }
      )
      .then(async res => {
        if(res.status === 200) {
          statesList =  await res.json(); 
          let statesFromApi =  statesList != null && statesList.items.map(state => {
            return {value: {id: state.id}, label: state.name}
          });
        
          dispatch({
            type:'UPDATE_STATES',
            payload: statesFromApi
          });
          SendMetrics({name: 'States.Count.Metrics', value: 1, userSession:state.user_session});

        }

      }).catch(error => {
        SendMetrics({name: 'States.Count.Metrics.Fail', value: 1, userSession: state.user_session});
        dispatch({
          type:'UPDATE_STATES',
          payload: {}
        });
        console.log(error);
      });
    }
  },
  [state.country],
  );

  const onChangeHandler = (action, payload) => {
    updateTouched(payload[0], true);
    dispatch({
      type: `${action}`,
      payload: payload
    });
  }

  const getCountyLabel = () => {
    //Check for edge cases and display if necessary.  This is required because you can't store translated words in translation files and they're
    //not intended to translate further.
    if (addressFields.County[1] !== undefined) {
      if (state.country === 'MX') {
        return 'Municipio';
      } 

      if (state.country === 'CL') {
        return 'Comuna'
      } 

      return t('personalInfo.' + addressFields.County[1])
    } 
    else 
    {
      return t('personalInfo.county', 'County')
    }
  }

  const onBlurHandler = (e, pattern) => {
    const val = _.trim(e.target.value);
    const name = e.target.name;
    dispatch({type: 'UPDATE_TAX_FIELDS', payload: [name, val]});
    updateTouched(name, false);
    const translatedName = t('personalInfo.'+ name);
    
    if(val === '') {
      updateError(name, false, '', <Trans i18nKey='personalInfo.requiredMsg'>A value for {translatedName} is required.</Trans>);
      
    } else if(!val.match(pattern)) {
      updateError(name, false, '', t('regExpr.'+ name));
      
    } else {
      updateError(name, true, val, '');
    } 
  }


  const addressFieldsCheck = (e, addressInfo) => {
    const val = _.trim(e.target.value);
    const name = e.target.name;
    dispatch({type: 'UPDATE_ADDRESS', payload: [name, val]});
    updateTouched(name, false);
    const translatedName = t('personalInfo.'+ name);
    
    if(addressInfo[0] === 'R' && val === '') {
      updateError(name, false, '', <Trans i18nKey='personalInfo.requiredMsg'>A value for {translatedName} is required.</Trans>);
      
    } else if(name === 'postalcode' && !val.match(addressInfo[1])) {
      updateError(name, false, '', t('regExpr.'+ addressInfo[2]));
      
    } else {
      updateError(name, true, val, '');
    }
  }

  const stateCheck = (val) => {
    updateError('state', true, val, '');
  }

  const provinceCheck = (val) => {
    updateError('province', true, val, '');
  }

  return (
    <>
      <form autoComplete="off">
      {addressFields !== undefined ? 
      <>
      {addressFields.Address1 !== undefined &&
        <RedwoodInputText type="text" 
          placeholder={t('personalInfo.addressPlaceholder')}
          label={`${addressFields.Address1[1] !== undefined ? t('personalInfo.' + addressFields.Address1[1]) : t('personalInfo.address1', 'Address Line 1')}`}
          name="address1"
          disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.address1) ? true : false}
          valid={error.address1 !== undefined ? error.address1.isValid: true} 
          value={state.address.address1}
          required = {addressFields.Address1[0] === 'R' ? 'required' : null}
          error={error.address1 !== undefined ? error.address1.msg: ''}
          onChange={e => onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])}
          onBlur={e => addressFieldsCheck(e, addressFields.Address1)}
        /> 
      }
      
      {addressFields.Address2 !== undefined &&
        <RedwoodInputText type="text" 
          placeholder={t('personalInfo.addressPlaceholder')}
          label={`${addressFields.Address2[1] !== undefined ? t('personalInfo.' + addressFields.Address2[1]) : t('personalInfo.address2', 'Address Line 2')}`}
          name="address2" 
          disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.address2) ? true : false}
          valid={error.address2 !== undefined ? error.address2.isValid: true}
          value={state.address.address2}
          required = {addressFields.Address2[0] === 'R' ? 'required' : null}
          error={error.address2 !== undefined ? error.address2.msg: ''}
          onChange={e => onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])}
          onBlur={e => addressFieldsCheck(e, addressFields.Address2)}
        />
      }

      {addressFields.Address3 !== undefined && 
        <RedwoodInputText type="text" 
          placeholder={t('personalInfo.addressPlaceholder')}
          label={`${addressFields.Address3[1] !== undefined ? t('personalInfo.' + addressFields.Address3[1]) : t('personalInfo.address3', 'Address Line 3')}`}
          name="address3" 
          disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.address3) ? true : false}
          valid={error.address3 !== undefined ? error.address3.isValid: true}
          value={state.address.address3}
          required = {addressFields.Address3[0] === 'R' ? 'required' : null}
          error={error.address3 !== undefined ? error.address3.msg: ''}
          onChange={e => onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])}
          onBlur={e => addressFieldsCheck(e, addressFields.Address3)}
        />
      }
      
      {addressFields.Address4 !== undefined &&
        <RedwoodInputText type="text" 
          placeholder={t('personalInfo.addressPlaceholder')}
          label={`${addressFields.Address4[1] !== undefined ? t('personalInfo.' + addressFields.Address4[1]) : t('personalInfo.address4', 'Address Line 4')}`}
          name="address4" 
          disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.address4) ? true : false}
          valid={error.address4 !== undefined ? error.address4.isValid: true}
          value={state.address.address4} 
          required = {addressFields.Address4[0] === 'R' ? 'required' : null}
          error={error.address4 !== undefined ? error.address4.msg: ''}
          onChange={e => onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])}
          onBlur={e => addressFieldsCheck(e, addressFields.Address4)}
        /> 
      }

      {addressFields.City !== undefined &&
        <RedwoodInputText type="text" 
          placeholder={t('personalInfo.cityPlaceholder')}
          label={`${addressFields.City[1] !== undefined ? ((state.country === 'CR') ? 'Canton' :t('personalInfo.' + addressFields.City[1])) : t('personalInfo.city', 'City')}`}
          name="city" 
          disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.city) ? true : false}
          valid={error.city !== undefined ? error.city.isValid: true}
          value={state.address.city} 
          required = {addressFields.City[0] === 'R' ? 'required' : null}
          error={error.city !== undefined ? error.city.msg: ''}
          onChange={e => onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])}
          onBlur={e => addressFieldsCheck(e, addressFields.City)}
        />
      }

      <div className="row">
        <div className={addressFields.State !== undefined || addressFields.Province !== undefined ? 'col-md-6 col-xs-12' : 'col-xs-0'}>
          {addressFields.State !== undefined && Object.keys(state.states).length !== 0 && 
            <RedwoodSelect type="text" 
              placeholder={t('personalInfo.statePlaceholder')}
              label={`${addressFields.State[1] !== undefined ? t('personalInfo.' + addressFields.State[1]) : t('personalInfo.state', 'State')}`}
              name="state" 
              value={state.address.selectedState} 
              data={state.states}
              required = {addressFields.State[0] === 'R' || addressFields.State[0] === 'R*' ? 'required' : null}
              onChange={e => {
                dispatch({
                  type: 'UPDATE_ADDRESS',
                  payload: ["selectedState", e]
                }); 
                dispatch({
                  type: 'UPDATE_ADDRESS',
                  payload: ["state", e.label]
                });
                stateCheck(e.value, addressFields.State)}
              }            
            />
          }
          {addressFields.State !== undefined && Object.keys(state.states).length === 0 && 
            <RedwoodInputText type="text" 
              placeholder={t('personalInfo.statePlaceholder')}
              label={`${addressFields.State[1] !== undefined ? t('personalInfo.' + addressFields.State[1]) : t('personalInfo.state', 'State')}`}
              name="state" 
              valid={error.state !== undefined ? error.state.isValid: true}
              value={state.address.state} 
              disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.province) ? true : false}
              required = {addressFields.State[0] === 'R' || addressFields.State[0] === 'R*' ? 'required' : null}
              error={error.state !== undefined ? error.state.msg: ''}
              onChange={e => {
                addressFields.State[0] === 'R*' ? 
                onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value.toUpperCase()])
                :
                onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])
              }}
              onBlur={e => addressFieldsCheck(e, addressFields.State)}
            />
          }

          {addressFields.Province !== undefined && (state.country === 'CA' || state.country === 'IT' || state.country === 'ES' || state.country === 'PS') &&
          <RedwoodSelect type="text" 
            placeholder={t('personalInfo.provincePlaceholder')}
            label={`${addressFields.Province[1] !== undefined ? t('personalInfo.' + addressFields.Province[1]) : t('personalInfo.province', 'Province')}`}
            name="province" 
            data={state.states}
            value={state.address.selectedProvince}
            required = {addressFields.Province[0] === 'R' || addressFields.Province[0] === 'R*' ? 'required' : null}
            onChange={e => {
              dispatch({
                type: 'UPDATE_ADDRESS',
                payload: ["selectedProvince", e]
              }); 
              dispatch({
                type: 'UPDATE_ADDRESS',
                payload: ["province", e.label]
              });
              provinceCheck(e.value, addressFields.Province)}
            }   
          />
        }
        {addressFields.Province !== undefined && !(state.country === 'CA' || state.country === 'IT' || state.country === 'ES' || state.country === 'PS') && 
          <RedwoodInputText type="text" 
            placeholder={t('personalInfo.provincePlaceholder')}
            label={`${addressFields.Province[1] !== undefined ? t('personalInfo.' + addressFields.Province[1]) : t('personalInfo.province', 'Province')}`}
            name="province" 
            disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.province) ? true : false}
            valid={error.province !== undefined ? error.province.isValid: true}
            value={state.address.province}
            required = {addressFields.Province[0] === 'R' || addressFields.Province[0] === 'R*' ? 'required' : null}
            error={error.province !== undefined ? error.province.msg: ''}
            onChange={e => {
              addressFields.Province[0] === 'R*' ? 
              onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value.toUpperCase()])
              :
              onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])
            }}
            onBlur={e => addressFieldsCheck(e, addressFields.Province)}
          />
        }
        </div>

        <div className={addressFields.State !== undefined || addressFields.Province !== undefined ? 'col-md-6 col-xs-12' : 'col-xs-12'}>
          {addressFields.PostalCode !== undefined &&
            <RedwoodInputText type="text" 
              placeholder={t('personalInfo.zipPlaceholder')}
              label={t('personalInfo.zip', 'Zip/Postal Code')}
              name="postalcode" 
              disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.postalcode) ? true : false}
              valid={error.postalcode !== undefined ? error.postalcode.isValid: true} 
              value={state.address.postalcode} 
              required = {addressFields.PostalCode[0] === 'R' || addressFields.PostalCode[0] === 'R*' ? 'required' : null}
              error={error.postalcode !== undefined ? error.postalcode.msg: ''}
              onChange={e => {
                addressFields.PostalCode[0] === 'R*' ? 
                onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value.toUpperCase()])
                
                :
                onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])
              }}
              onBlur={e => addressFieldsCheck(e, addressFields.PostalCode)}
            />
          }
        </div>
      </div>
      {addressFields.County !== undefined &&
        <RedwoodInputText type="text" 
          placeholder={t('personalInfo.countyPlaceholder')}
          label={getCountyLabel()}
          name="county" 
          disabled={!_.isEmpty(state.selectedPromo) &&  !_.isEmpty(state.selectedPromo.address) && !_.isEmpty(state.selectedPromo.address.county) ? true : false}
          valid={error.county !== undefined ? error.county.isValid: true}
          value={state.address.county}
          required = {addressFields.County[0] === 'R' ? 'required' : null}
          error={error.county !== undefined ? error.county.msg: ''}
          onChange={e => onChangeHandler('UPDATE_ADDRESS', [e.target.name, e.target.value])}
          onBlur={e => addressFieldsCheck(e, addressFields.County)}
        />
      }

      {state.country === 'BR' && taxInfo !== undefined && 
        <RedwoodInputText type="text" 
          label={`${state.companyName === "" ? 'CPF' : 'CNPJ'}`}
          name="taxPayerId" 
          value={state.taxPayerId}
          valid={error.taxPayerId !== undefined ? error.taxPayerId.isValid: true}
          required = {taxInfo.TaxPayerID[1] === 'R' ? 'required' : null}
          error={state.companyName === "" ? t('regExpr.brCpfMsg'): t('regExpr.brCnpjMsg')}
          onChange={e => onChangeHandler('UPDATE_TAX_FIELDS', [e.target.name, e.target.value])}
          onBlur={e => {
            state.companyName === "" ? onBlurHandler(e,  taxInfo.TaxPayerID[5]) : onBlurHandler(e, taxInfo.TaxPayerID[2])
          }}
        />
      }
      
      <Button type="solid" disabled={state.selectedPromo.country ? state.addressContinueBtn : verifyAddress()} onClick={e => doClick(e)} text={t('termsOfUse.continue','Continue')}></Button>
      
    </> 
      : <></>}
      </form>
    </>
  )
}

export default PersonalInfoComponent;
